{
  "version": 1,
  "asset_id": "4fb8dbca-9046-4f52-a130-c03fe5cce7b7",
  "project_id": "288ffafd-b4ec-4687-a58e-f3a6c56e4541",
  "url": "/__l5e/assets-v1/4fb8dbca-9046-4f52-a130-c03fe5cce7b7/home-video-new.mp4",
  "r2_key": "a/v1/288ffafd-b4ec-4687-a58e-f3a6c56e4541/4fb8dbca-9046-4f52-a130-c03fe5cce7b7/home-video-new.mp4",
  "original_filename": "home-video-new.mp4",
  "size": 4285456,
  "content_type": "video/mp4",
  "created_at": "2026-08-31T18:30:31Z"
}
